export default __webpack_public_path__ + "static/sustainability-4-f994f228d3fec47652fa6975168d728e.jpg";